<!-- Formulario Dispositivos -->
<div class="row mx-0 w-100" *ngFor="let sign of deviceSignalingTaskActivities; index as indexOfSign">
  <div class="col d-flex sign-container mb-4 w-100">
    <div class="col-1 pt-2 d-flex justify-content-center">
      <img [src]="sign['svg'] ? sign['svg'] : 'assets/icons/d-task-icon.svg'" alt="" height="48px" width="48px" />
    </div>
    <div class="col mt-2">
      <div class="content-contractual">
        <form #deviceForm="ngForm">
          <div class="snow-light-container mb-3" *ngIf="stockEntries?.length && !isStock">
            <div class="row mx-0 d-flex align-items-center justify-content-between">
              <div class="col custom-control custom-radio mb-2">
                <input
                  type="radio"
                  name="contractOrStockRadio{{ indexOfSign + 1 }}"
                  id="contractOrStockRadio{{ indexOfSign + 1 }}1"
                  class="custom-control-input cursor-pointer"
                  (change)="setBond('contract', indexOfSign)"
                  [checked]="radioState[indexOfSign]?.contract"
                />
                <label
                  class="custom-control-label pl-2"
                  style="font-size: 16px"
                  for="contractOrStockRadio{{ indexOfSign + 1 }}1"
                  >Item do Contrato</label
                >
              </div>
              <div class="col custom-control custom-radio mb-2">
                <input
                  type="radio"
                  name="contractOrStockRadio{{ indexOfSign + 1 }}"
                  id="contractOrStockRadio{{ indexOfSign + 1 }}2"
                  class="custom-control-input cursor-pointer"
                  (change)="setBond('stock', indexOfSign)"
                  [checked]="radioState[indexOfSign]?.stock"
                />
                <label
                  class="custom-control-label pl-2"
                  style="font-size: 16px"
                  for="contractOrStockRadio{{ indexOfSign + 1 }}2"
                  >Vínculo com Estoque</label
                >
              </div>
            </div>
            <div class="form-group snow-light-container" *ngIf="radioState[indexOfSign]?.contract">
              <label for="contractBond">Selecione o item do Contrato</label>
              <select
                name="contractBond"
                class="form-control"
                [(ngModel)]="sign.contractDeviceItemId"
                required
                autocomplete="off"
                list="contractItems"
                (change)="sign.contractDeviceItemId = $event.target.value; setContractItem(sign); emitValidation(sign)"
              >
                <option value="" hidden>Selecione...</option>
                <option *ngFor="let item of deviceItems" [value]="item.id">{{ item?.name }}</option>
              </select>
            </div>
            <div class="form-group" *ngIf="radioState[indexOfSign]?.stock">
              <label for="stockedTrafficSignId">Selecione o item do Estoque</label>
              <select
                name="stockedTrafficSignId"
                class="form-control"
                [(ngModel)]="sign.stockedDeviceSignalingId"
                list="stockList"
                required
                (change)="setContractItem(sign, $event.target.value, indexOfSign); emitValidation(sign)"
              >
                <option [value]="undefined" hidden>Selecione...</option>
                <option *ngFor="let item of stockEntries" [value]="item.id">
                  {{
                    item.contractDeviceItem.name + ' - ' + (item.quantity - item.quantityRegistered) + ' disponíveis'
                  }}
                </option>
              </select>
            </div>
          </div>
          <div class="row mx-0 d-flex align-items-center" *ngIf="isStock || (!stockEntries?.length && !isStock)">
            <div class="col-2 px-0 mr-4" *ngIf="isStock">
              <div class="form-group">
                <label for="quantity">Quantidade</label>
                <input
                  name="quantity"
                  [(ngModel)]="sign.quantityToBeRegistered"
                  required
                  class="form-control"
                  type="number"
                  placeholder="0"
                  min="0"
                  oninput="if(this.value < 0) this.value = 0;"
                  (change)="verifyQuantity(indexOfSign); emitValidation(sign); setDeviceCost(sign)"
                  [dropSpecialCharacters]="false"
                />
              </div>
            </div>
            <div class="col px-0">
              <div class="form-group snow-light-container">
                <label for="contractDeviceItemId">Selecione o item do Contrato</label>
                <select
                  name="contractDeviceItemId"
                  class="form-control"
                  required
                  (change)="
                    sign.contractDeviceItemId = $event.target.value;
                    setContractItem(sign, undefined, indexOfSign);
                    emitValidation(sign);
                    sign.dimension = 0;
                    sign.units = 0
                  "
                  [(ngModel)]="sign.contractDeviceItemId"
                >
                  <option value="" hidden>Selecione...</option>
                  <option *ngFor="let option of deviceItems" [value]="option.id">{{ option?.name }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col d-flex flex-column px-4 dimension-container">
            <p class="text-uppercase text-muted mb-2">APLICAÇÃO</p>
            <div class="row mx-0 d-flex align-items-center">
              <div class="col pl-0 pr-1 pl-0 w-100">
                <label>Unidades</label>
                <input
                  name="units"
                  required
                  type="number"
                  class="form-control"
                  placeholder="0"
                  [disabled]="sign.contractDeviceItem.unit == itemUnitEnum.m && !sign.stockedDeviceSignalingId"
                  [(ngModel)]="sign.units"
                  (change)="setDeviceCost(sign); emitValidation(sign)"
                  min="0"
                  oninput="if(this.value < 0) this.value = 0"
                  [dropSpecialCharacters]="false"
                />
              </div>
              <div class="col pl-1 pr-0 w-100">
                <label>Extensão Aplicada (m)</label>
                <input
                  name="dimension"
                  required
                  type="number"
                  class="form-control"
                  [(ngModel)]="sign.dimension"
                  [disabled]="sign.contractDeviceItem.unit == itemUnitEnum.und && !sign.stockedDeviceSignalingId"
                  placeholder="0"
                  (change)="setDeviceCost(sign); emitValidation(sign)"
                  min="0"
                  oninput="if(this.value < 0) this.value = 0"
                  [dropSpecialCharacters]="false"
                />
              </div>
            </div>
          </div>
        </form>
        <div class="row mx-0 my-2">
          <div class="col-4 px-0">
            <div class="px-0 form-group">
              <label for="legend">Determine o tempo de garantia*</label>
              <div class="row d-flex align-items-center justify-content-between mx-0">
                <div class="position-relative w-100">
                  <input
                    bsDatepicker
                    class="form-control"
                    #wDate
                    [ngModel]="dateService.TransformDate(sign, 'get')"
                    [bsConfig]="{
                      isAnimated: true,
                      containerClass: 'theme-dark-blue',
                      dateInputFormat: 'DD-MM-YYYY',
                      showWeekNumbers: false
                    }"
                    (bsValueChange)="
                      dateService.TransformDate(sign, 'set', wDate.value);
                      setWarranty($event, sign);
                      emitValidation(sign)
                    "
                  />
                  <i
                    class="fa-solid fa-calendar position-absolute"
                    (click)="dp.show()"
                    style="right: 5%; top: 35%; cursor: text"
                  ></i>
                </div>
              </div>
            </div>
          </div>
          <div class="align-items-center d-flex col px-0">
            <div *ngIf="true" class="d-flex justify-content-between flex-column col-4">
              <a
                style="font-size: 20px; color: var(--greenmix-light); pointer-events: none"
                [ngClass]="{ 'text-danger': sign['active'] > 1 }"
              >
                {{
                  !sign['warrantyTextCurrent'] || sign['warrantyTextCurrent'] == 0
                    ? 'Sem período'
                    : sign['warrantyTextCurrent']
                }}</a
              >
              <a
                [ngClass]="{ 'text-danger': sign['active'] > 1 }"
                style="
                  color: var(--red-base);
                  font-weight: 500;
                  font-size: 14px;
                  color: var(--greenmix-light);
                  pointer-events: none;
                  white-space: nowrap;
                "
              >
                {{ sign.warranty ? (sign.warranty | date: 'dd/MM/yyyy') : 'Escolha a data de expiração' }}</a
              >
            </div>
            <div class="col px-0">
              <progressbar
                *ngIf="sign['active'] == 1"
                class="mx-4"
                style="border-radius: 8px; height: 8px; width: 100%"
                [value]="sign['progress'] * 100"
                type="success"
              >
              </progressbar>
              <progressbar
                *ngIf="sign['active'] > 1"
                class="mx-4"
                style="border-radius: 8px; height: 8px; width: 100%"
                [value]="sign['progress'] * 100"
                type="danger"
              >
              </progressbar>
            </div>
            <div class="d-flex justify-content-between flex-column align-items-end col px-0">
              <a
                *ngIf="sign['warrantyTextCurrent'] !== 0"
                style="font-size: 20px; color: var(--gray-light); pointer-events: none"
                >{{ sign.warranty ? (sign.warranty | date: 'dd/MM/yyyy') : 'Sem Período' }}</a
              >
              <a
                *ngIf="sign['warrantyTextCurrent'] == 0"
                style="color: var(--red-base); font-weight: 500; font-size: 16px; pointer-events: none"
                ><i class="fa-solid fa-triangle-exclamation" style="margin-right: 8px; font-size: 20px"></i>Garantia
                Expirada</a
              >
              <h4 class="mt-2" style="color: var(--gray-light)" *ngIf="sign['warrantyTextCurrent'] !== 0">
                Sem última edição
              </h4>
            </div>
          </div>
        </div>
        <div class="row px-4 justify-content-between align-items-center my-2 py-2">
          <div class="col px-0">
            <div>
              <label for="signQuant" class="text-muted">Sinalização</label>
              <p>
                {{
                  sign.contractDeviceItem.signaling
                    ? (sign.contractDeviceItem.signaling | enumText: 'Signaling')
                    : 'Não informado'
                }}
              </p>
            </div>
          </div>
          <div class="col px-0">
            <label for="signQuant" class="text-muted">Unidades</label>
            <p>{{ sign.units }}</p>
          </div>
          <div class="col px-0">
            <label for="signQuant" class="text-muted">Vr. Unt. da Sinalização</label>
            <p class="text-success">
              {{
                sign.contractDeviceItem
                  ? ((sign.contractDeviceItem.unit === 'm' || sign.contractDeviceItem.unit === 'm²'
                      ? (sign.dimension || 0) * sign.contractDeviceItem.unitValue
                      : sign.contractDeviceItem.unitValue)
                     | currency:'BRL':'R$')
                  : 'R$0,00'
              }}
            </p>
          </div>
          <div class="col px-0">
            <label for="signQuant" class="text-muted">Valor do Item</label>
            <p>
              {{
                sign.contractDeviceItem
                  ? (sign.contractDeviceItem.unitValue | currency:'BRL':'R$') + '/' + sign.contractDeviceItem.unit
                  : 'R$0,00/--'
              }}
            </p>
          </div>
          <div class="col px-0">
            <label for="signQuant" class="text-muted">Valor Total</label>
            <p class="text-success">
              {{
                sign.contractDeviceItem
                  ? ((sign.units > 1 ? sign.units : sign.dimension) *
                      (isStock ? sign.quantity : 1) *
                      sign.contractDeviceItem.unitValue | currency:'BRL':'R$')
                  : 'R$0,00'
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-auto px-0 pl-4" *ngIf="!isStock">
    <button class="btn btn-icon btn-icon-alt" (click)="removeActivity(indexOfSign)">
      <i class="fa-regular fa-xmark fa-lg text-danger"></i>
    </button>
  </div>
</div>
